import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import { deleteMeetingPlace, getMeetingPlace, getMeetingPlaceList, postMeetingPlace, putMeetingPlace } from "./api";
import { MessageType } from "types/enum";


interface Form {      

}
export const MeetingPlace = ({ }: Form) => {
    const [response, setResponse] = useState<Response | any>(null);
    const [selectedObj, setSelectedObj] = useState< any>(null);
    const [mode, setMode] = useState("create");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [flag, setFlag] = useState(false);
    const [resetForm, setResetForm] = useState(false);
    const [editForm, setEditForm] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [userChanges, setUserChanges] = useState({});
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [pages, setPages] = useState<number>(0);




    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("MeetingPlace" ,e.currentTarget.value )
        getMeetingPlaceListAsync(1)
      };


      function handleGoPage(value): void {
        if (value) {
            if (value < 1 || value > pages) { }
            else {setPageNum(+value);getMeetingPlaceListAsync(+value)}
        } else {
        }
    }
    
    const handleNextPage = () => {
        if(pageNum < pages){
            setPageNum(pageNum + 1);
            getMeetingPlaceListAsync(pageNum + 1);
          };
    };
    const handlePrevPage = () => {
        if(pageNum > 1){
            setPageNum((pageNum)=>{return +pageNum - 1});
            getMeetingPlaceListAsync(pageNum - 1);
          };
    };


    const searchHandler = (str) => {
        if(str =="" ){
            setSearch(null)
        }else{
            setSearch(str)
        }
      }
    const handleCreateAction = () => {
        setEditForm(null)
        setMode("create")
        setUserChanges({})
        setShowForm(true)
    }

    const handleEditRow = () => {
        setMode("edit");
        setShowForm(true)
    }
    const handleDeleteRow = async() => {
        try {
            await deleteMeetingPlace(selectedObj.Id)
            setForceUpdate(!forceUpdate)
        } catch (error) {
            
        }
    }
    
    const handleViewRow = () => {
        setMode("view")
        setShowForm(true)
    }

    const selectedIdCallback = (obj, index) => {
        
        if(sessionStorage.getItem("changingforms")+""=="true"){
            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); setUserChanges({}) });
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); setUserChanges({}) });

        }else{
            setSelectedObj(obj)         
        };
    }

    const submit =async (e) => {
        e.preventDefault();
        if (editForm == null) {
            postMeetingPlace({     
                Title: e.target.Title.value,
                Capacity: +e.target.Capacity.value,
                Facilities : e.target.Facilities.value,
                Address: e.target.Address.value,
                Description: e.target.Description.value,
            }).then(() => { sessionStorage.setItem("changingforms" , "false");setUserChanges({});getMeetingPlaceListAsync();cancel(); });
        } else {
            putMeetingPlace({
                 Title: e.target.Title.value,
                  ActivityStatus: +e.target.ActivityStatus.value , 
                  Capacity: +e.target.Capacity.value,
                  Facilities : e.target.Facilities.value,
                  Address: e.target.Address.value,
                  Description: e.target.Description.value,
                  Id: selectedObj.Id?selectedObj?.Id : editForm.Id ,
             }).then(() => { sessionStorage.setItem("changingforms" , "false");setUserChanges({});getMeetingPlaceListAsync();cancel(); })
        }
    }

    function cancel() {
        if(sessionStorage.getItem("changingforms")+""=="true"){
            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
            //     sessionStorage.setItem("changingforms" , "false");
            //     setUserChanges({});
            //     setEditForm(null);
            //     setShowForm(false)
            // });
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                sessionStorage.setItem("changingforms" , "false");
                setUserChanges({});
                setEditForm(null);
                setShowForm(false)
            });
        }else{
            setEditForm(null);
            setShowForm(false)     
        };


    }
    async function getMeetingPlaceListAsync(PageNum =pageNum) {
        setLoading(false)
        let pageSizeChangedByUser = getPageSize("MeetingPlace" )
        setPageSize(pageSizeChangedByUser)
        try {
            const res = await getMeetingPlaceList(search ,orderBy.length == 0 ?null:  orderBy.join(",") ,PageNum,pageSizeChangedByUser);
            setResponse(res.Data);
            setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) 
           
            setCatchMessage({type:"info",msg:"NoDataForPreview"})
        } catch (error:any) {
            setCatchMessage({type:"error" , msg:error?.response?.data?.Message})
        }
        setLoading(true)
    }
    async function getMeetingPlaceAsync() {
        setFormLoading(false)
        try {
            const data = await getMeetingPlace(selectedObj?.Id );
            setEditForm({Id: selectedObj?.Id  ,Title: data.Data.Title , Capacity: data.Data.Capacity , Address: data.Data.Address , Description: data.Data.Description , Facilities: data.Data.Facilities , Status: data.Data.ActivityStatus,
            });
        } catch (error) {
            
        }
         setFormLoading(true)

    }
    useEffect(() => {
        getMeetingPlaceListAsync();
    }, [forceUpdate, flag  ,search , orderBy]);

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
        }
    }, [resetForm]);
    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
      };


    useEffect(() => {
        if(Object.values(userChanges).filter((item)=>item!=null).length>0){

            sessionStorage.setItem("changingforms" , "true")
              window.addEventListener('beforeunload', handleBeforeUnload);
              return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
              };
        }else{
            sessionStorage.setItem("changingforms" , "false")
            window.removeEventListener('beforeunload', handleBeforeUnload);

        }
    }, [userChanges]);
    useEffect(() => {
        if(showForm &&selectedObj && mode != "create"){
           getMeetingPlaceAsync()
        }else{
            setFormLoading(true)
        }
    }, [selectedObj ,showForm ,mode]);



 

    /* #endregion */

    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel":downloadCSV(response ,1 ,trans("MeetingPlace"));break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateAction(); break;
            case "remove": if (selectedObj?.Id)Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , handleDeleteRow); break;
            case "view": if (selectedObj?.Id) handleViewRow(); break;
            // case "edit": if (selectedObj?.Id)selectedObj.SystemReserved ? Toast(trans("Msg_CanNotEditSystemReservedData") , "error") : handleEditRow(); break;
            case "edit": if (selectedObj?.Id)selectedObj.SystemReserved ? Toast(trans("Msg_CanNotEditSystemReservedData") , MessageType.error) : handleEditRow(); break;

            case "help": alert("call api help"); break;
        }
    };
    /* #endregion */
    return (
        <>
            <div className="cartable-action">
                <Toolbar handleSearch={searchHandler}  id={selectedObj?.Id} emptyList={response == null || response?.length == 0} create={true} remove={true} edit={true} search={true} handleClickToolbar={clickToolbarCallback} />
                <div className="card">
                    <div className="">
                        {loading ?
                            <>
                                {showForm&& 
                                <>               
                                    <div className="card mb-4">
                                    {formLoading?
                                        <form className="TypeSettingForm row card-body " onSubmit={submit}>
                                        <div className="col-md-3 col-sm-12">
                                            <Textbox Change={(e)=>{setUserChanges({...userChanges , ...e})}} required={true} textboxName={"Title"} textboxType="text" resetForm={resetForm} labelText={"Title"} mode={mode}  defaultValue={editForm?.Title} />
                                        </div>
                                        <div className="col-md-1 col-sm-12">
                                            <Textbox Change={(e)=>{setUserChanges({...userChanges , ...e})}}  textboxName={"Capacity"} textboxType="number" resetForm={resetForm} labelText={"Capacity"} mode={mode}  defaultValue={editForm?.Capacity} />
                                        </div>
                                       
                                      
                                        <div className="col-md-3 col-sm-12">
                                            <Textbox Change={(e)=>{setUserChanges({...userChanges , ...e})}}  textboxName={"Address"} textboxType="text" resetForm={resetForm} labelText={"Address"} mode={mode}  defaultValue={editForm?.Address} />
                                        </div> 
                                          {mode != "create" &&          
                                        <div className="col-md-3 col-sm-12 ">
                                            <EnumerationTypeSelect
                                             Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
                                             name="ActivityStatus"
                                             enumTypeSelect="ActivityStatus"
                                             mode={mode} 
                                             label="Status" 
                                             value={editForm?.Status}
                                            />
                                        </div>                            
                                        }
                                          <div className="col-md-6 col-sm-12">
                                            <Textbox Change={(e)=>{setUserChanges({...userChanges , ...e})}}  textboxName={"Facilities"} textboxType="textarea" resetForm={resetForm} labelText={"facilities"} mode={mode}  defaultValue={editForm?.Facilities} />
                                        </div>       
                                        <div className="col-md-6 col-sm-12">
                                            <Textbox Change={(e)=>{setUserChanges({...userChanges , ...e})}}  textboxName={"Description"} textboxType="textarea" resetForm={resetForm} labelText={"Description"} mode={mode}  defaultValue={editForm?.Description} />
                                        </div> 
                                       
   
                                        { mode !="view" ?
                                            <div className="col-lg-12 mt-1 btns_form">
                                              <Button value="Save" btnType="submit" />
                                              <Button btnType="cancel" value="Cancel" onClick={()=>{cancel()}} />
                                            </div>
                                            :
                                            <div className="col-lg-12 mt-1 btns_form">
                                              <Button btnType="primary" value="close" onClick={()=>{cancel()}} />
                                            </div>
                                        }                        
                                        </form>
                                    :
                                    <Loading />
                                    }             
                                    </div >
                                </>
                                }
                                {
                                    loading ?
                                    response?.Data?.length > 0 ?
                                        <>
                                            <DataGrid
                                                orderFormat={setOrderBy}
                                                orderFormatList={orderBy}
                                                parentName={"MeetingPlace"}
                                                startIndex={1}
                                                theadData={Object.keys(response.Data[0])}
                                                tbodyData={response.Data}
                                                minCellWidth={80}
                                                scrollHeight={showForm? "25vh": "67vh"}
                                                selectedRowObjectCallback={selectedIdCallback}
                                                handleEdit={handleEditRow}
                                                // handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), "warning" , "alert" ,handleDeleteRow)}}
                                                handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete,handleDeleteRow)}}

                                                handleView={handleViewRow}
                                                totalRecords={response.TotalRecords}
                                                pageNum={pageNum}
                                                pageSize={pageSize}
                                                HandleNextPage={handleNextPage}
                                                HandlePrevPage={handlePrevPage}
                                                handlechangePageSize={handleChangePageSize}
                                                first={() =>{getMeetingPlaceListAsync(pages); setPageNum(pages)}}
                                                end={() =>{getMeetingPlaceListAsync(1); setPageNum(1)}}
                                                handleGoPage={handleGoPage}
                                            />
                                        </>
                                : <Message message={catchMessage.msg} type={catchMessage.type} />
                                :<Loading/>
                                }
                            </>
                            : <Loading />
                        }
                    </div>
                </div>
            </div>
        </>

    );
}